import { FC } from 'react';
import Layout from '@/components/layout/Layout';
import BookCardItem from '@/components/ui/book-card-item/BookCardItem';
import Pagination from '@/components/ui/pagination/Pagination';
import PageHeading from '@/components/ui/page-heading/PageHeading';
import Breadcrumbs from '@/components/ui/breadcrumbs/Breadcrumbs';
import SectionTitleMenu from '@/components/ui/section-title-menu/SectionTitleMenu';
import { IBooksPage, IBooksPageData } from '@/interfaces/booksPage.interface';
import { useGetUrlPath } from '@/hooks/useGetUrlPath';
import { BOOKS_FOR_PAGE } from '@/helpers/variables';

const Rating: FC<IBooksPage> = ({ books }) => {
  const pagesCount = Math.ceil(books?.total_count / BOOKS_FOR_PAGE);

  //Seo block
  const SEO_TITLE = 'Рейтинг книг в электронной библиотеке Куча книг';
  const SEO_DESCRIPTION = 'На этой странице можно ознакомиться с рейтингом книг в электронной библиотеке Куча книг.';
  const SEO_CANONICAL = '/rating/books/';

  return (
    <Layout title={SEO_TITLE} description={SEO_DESCRIPTION} canonicalHref={SEO_CANONICAL} pageHref={useGetUrlPath()}>
      <Breadcrumbs pageName="Рейтинг книг" />

      <SectionTitleMenu>
        <PageHeading title="Рейтинг книг" extraClassName="pageHeading_plain" />
      </SectionTitleMenu>

      <div data-cards="list" className="cardsWrapper">
        {books.data.length ? (
          books.data.map((book: IBooksPageData) => (
            <BookCardItem createdAt={book.created_at} alias={book.alias} author={book.author} book={book.book} rating={book.rating} key={book.id} draft={book.draft} readOnline={book.read_online} retelling={!!book.retaling} />
          ))
        ) : (
          <div>Книги не найдены</div>
        )}
      </div>
      <Pagination pagesCount={pagesCount ?? 0} postName="rating/books/page=" />
      {/* <Breadcrumbs pageName="Рейтинг книг" isBottom={true} /> */}
    </Layout>
  );
};

export default Rating;
